import 'devextreme/dist/css/dx.light.css';
import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { Spin, Row, Col, Card } from 'antd';
import { CompareCompanySalesSelector, getCompareCompanySales, getComparePro2, getComparePro4, getCompareSlp } from '../../store/reducers/Report/compareCompanySales'
import { MasterDataSelector} from '../../store/reducers/masterData/masterData'
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { Chart, Series, CommonSeriesSettings, ArgumentAxis, Grid, Margin, Title, Subtitle } from 'devextreme-react/chart';
import { Legend, Tooltip, Export } from 'devextreme-react/pie-chart';
import { TimeDataSelCompareCompanySales } from '../data/data'
import { Select, DatePicker, Space } from 'antd';
import moment from 'moment';
import Flex from '../../components/shared-components/Flex'
import SelectBox from 'devextreme-react/select-box';
import axiosConfig from '../../configs/axios.config';
import axios from 'axios'

const { Option } = Select;
const { RangePicker } = DatePicker;
const weekFormat = 'MM/DD';


const WeeklyRevenue = ({ pfrmDate, ptoDate }) => {
    const frmDate = new Date(pfrmDate)
    const toDate = new Date(ptoDate)
    const CompareCompanySalesSelectors = useSelector(CompareCompanySalesSelector)
    function customizeTooltip(pointInfo) {
        return {
            text: `${pointInfo.point.data.DateToolTip ? pointInfo.point.data.DateToolTip : pointInfo.argumentText}: ${pointInfo.valueText}`,
        };
    }
    return (<Card>
        <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={8}>

                <Flex className="h-100" flexDirection="column" justifyContent="between">
                    <div>
                        <h4 className="mb-0">Doanh thu</h4>
                        <span className="text-muted">{frmDate.getDate()} - {toDate.getDate()}/{toDate.getMonth() + 1}, {toDate.getFullYear()}</span>
                    </div>
                    <div className="mb-4">
                        <h1 className="font-weight-bold">${Intl.NumberFormat('en-US').format(CompareCompanySalesSelectors.currentTotal)}</h1>
                        <p className={CompareCompanySalesSelectors.rateTotal > 0 ? "text-success" : "text-danger"}>
                            <span >
                                {CompareCompanySalesSelectors.rateTotal > 0 ? <ArrowUpOutlined className="text-success" /> : <ArrowDownOutlined className="text-danger" />}
                                <span> {Intl.NumberFormat('en-US').format(CompareCompanySalesSelectors.rateTotal > 0 ? CompareCompanySalesSelectors.rateTotal.toFixed(2) : (CompareCompanySalesSelectors.rateTotal * -1).toFixed(2))} </span>
                            </span>
                            <span>Tăng trưởng so với kỳ trước</span>
                        </p>
                        <p>Con số tổng thu nhập dựa trên phạm vi ngày được đưa ra ở trên.</p>
                    </div>
                </Flex>
            </Col>
            <Col xs={24} sm={24} md={24} lg={16}>
                <Chart
                    palette="Material"
                    dataSource={CompareCompanySalesSelectors.compareTotal}
                >
                    <CommonSeriesSettings
                        argumentField="DocDate"
                        type="line"
                    />
                    {
                        CompareCompanySalesSelectors.energySourcesTotal.map((item) => <Series
                            key={item.value}
                            valueField={item.value}
                            name={item.name} />)
                    }
                    <Margin bottom={20} />
                    <ArgumentAxis
                        valueMarginsEnabled={false}
                        discreteAxisDivisionMode="crossLabels"
                    >
                        <Grid visible={true} />
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="bottom"
                        horizontalAlignment="center"
                        itemTextPosition="bottom"
                    />
                    <Export enabled={false} />
                    <Title text="Doanh thu theo kỳ">
                        <Subtitle text="ĐVT: VNĐ" />
                    </Title>
                    <Tooltip enabled={true} format="###,###,###" />
                </Chart>
            </Col>
        </Row>
    </Card>)
}


const customWeekStartEndFormat = (value) =>
    `${moment(value).startOf('week').format(weekFormat)} ~ ${moment(value)
        .endOf('week')
        .format(weekFormat)}`;

const CompareCompanySales = () => {
    const CompareCompanySalesSelectors = useSelector(CompareCompanySalesSelector)
    const MasterDataSelectors = useSelector(MasterDataSelector)
    const dispatch = useDispatch()
    const [listPro2, setListPro2] = useState([])
    const [listPro4, setListPro4] = useState([])
    const [listSlp, setListSlp] = useState([])
    const [selectedTimeType, setselectedTimeType] = useState('year')
    const [loadData, setLoadData] = useState({ FrDate: moment().startOf('year').format('yyyy/MM/DD'), ToDate: moment().endOf('year').format('yyyy/MM/DD'), TypeReport: "Total", TimeType: "year" })
    const [loadDataPro2, setLoadDataPro2] = useState({ FrDate: moment().startOf('year').format('yyyy/MM/DD'), ToDate: moment().endOf('year').format('yyyy/MM/DD'), TypeReport: "pro2", TimeType: "year", Condition: "" })
    const [loadDataPro4, setLoadDataPro4] = useState({ FrDate: moment().startOf('year').format('yyyy/MM/DD'), ToDate: moment().endOf('year').format('yyyy/MM/DD'), TypeReport: "pro4", TimeType: "year", Condition: "" })
    const [loadDataSlp, setLoadDataSlp] = useState({ FrDate: moment().startOf('year').format('yyyy/MM/DD'), ToDate: moment().endOf('year').format('yyyy/MM/DD'), TypeReport: "Slp", TimeType: "year", Condition: "" })
    useEffect(() => {
        async function LoadComBoBox() {
            let response
            let docList
            response = await axios.create(axiosConfig).post(`api/MasterData/GetBytable`, { TableName: "@ITEMPRO_4" })
            if (response.data.success) {
                setListPro4(response.data.result)
                setLoadDataPro4({ ...loadDataPro4, Condition: response.data.result[0].Code })
            }
            else {
                console.log(response.data)
            }
            response = await axios.create(axiosConfig).post(`api/MasterData/GetBytable`, { TableName: "@ITEMPRO_2" })
            if (response.data.success) {
                setListPro2(response.data.result)
                setLoadDataPro2({ ...loadDataPro2, Condition: response.data.result[0].Code })
            }
            else {
                console.log(response.data)
            }
            response = await axios.create(axiosConfig).get(`api/MasterData/GetSlp`)
            if (response.data.success) {
                setListSlp(response.data.result)
                setLoadDataSlp({ ...loadDataSlp, Condition: response.data.result[0].SlpCode })
            }
            else {
                console.log(response.data)
            }
        }
        LoadComBoBox()
    }, [])


    useEffect(() => {
        if (selectedTimeType === 'RangePicker') {
        }
        else if (selectedTimeType === 'week') {
            const startDate = moment().startOf('week').format('yyyy/MM/DD')
            const endDate = moment().endOf('week').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
        else if (selectedTimeType === 'month') {
            const startDate = moment().startOf('month').format('yyyy/MM/DD')
            const endDate = moment().endOf('month').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
        else if (selectedTimeType === 'year') {
            const startDate = moment().startOf('year').format('yyyy/MM/DD')
            const endDate = moment().endOf('year').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
        else if (selectedTimeType === 'quarter') {
            const startDate = moment().startOf('quarter').format('yyyy/MM/DD')
            const endDate = moment().endOf('quarter').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
    }, [selectedTimeType])
    useEffect(() => {
        dispatch(getCompareCompanySales(loadData))
    }, [loadData])
    useEffect(() => {
        dispatch(getComparePro2(loadDataPro2))
    }, [loadDataPro2])
    useEffect(() => {
        dispatch(getComparePro4(loadDataPro4))
    }, [loadDataPro4])
    useEffect(() => {
        dispatch(getCompareSlp(loadDataSlp))
    }, [loadDataSlp])

    const handleChange = (value) => {
        setselectedTimeType(value)
    };
    const SelectBoxChange = (e) => {
        setLoadDataPro2({ ...loadDataPro2, Condition: e.value })
    }
    const SelectBoxChangePro4 = (e) => {
        setLoadDataPro4({ ...loadDataPro4, Condition: e.value })
    }
    const SelectBoxChangeSlp = (e) => {
        setLoadDataSlp({ ...loadDataSlp, Condition: e.value })
    }
    const dateChange = (date, datestring) => {
        if (date) {
            if (selectedTimeType === 'week') {
                const startDate = moment(date).startOf('week').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('week').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
                setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate })
                setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            }
            else if (selectedTimeType === 'month') {
                const startDate = moment(date).startOf('month').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('month').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
                setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate })
                setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            }
            else if (selectedTimeType === 'year') {
                const startDate = moment(date).startOf('year').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('year').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
                setLoadDataPro2({ ...loadDataPro2, FrDate: startDate, ToDate: endDate })
                setLoadDataPro4({ ...loadDataPro4, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setLoadDataSlp({ ...loadDataSlp, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            }
        }
    }
    const PickerWithType = ({ type, onChange }) => {
        if (type === 'date') return <DatePicker onChange={onChange} />;
        if (type === 'RangePicker') return <RangePicker format={'DD/MM/yyyy'} onChange={onChange} defaultValue={[moment(loadData.FrDate), moment(loadData.ToDate)]} />;
        if (type === 'week') return <DatePicker format={customWeekStartEndFormat} onChange={onChange} picker="week" defaultValue={moment(loadData.FrDate)} />;
        if (type === 'year') return <DatePicker onChange={onChange} picker="year" defaultValue={moment(loadData.FrDate, 'YYYY')} />;
        if (type === 'month') return <DatePicker onChange={onChange} picker="month" defaultValue={moment(loadData.FrDate, 'YYYY/MM')} />;
        return <DatePicker picker={type} onChange={onChange} defaultValue={moment(loadData.FrDate)} />;
    };
    return (
        <>
            <Space style={{marginBottom: '16px'}}>
                <Select defaultValue={selectedTimeType} style={{ width: 250 }} onChange={handleChange}>
                    {TimeDataSelCompareCompanySales.map((TimeDataSel, index) => (
                        <Option key={index} value={TimeDataSel.val}>{TimeDataSel.displayvalue}</Option>
                    ))}
                </Select>
                <PickerWithType type={selectedTimeType} onChange={dateChange} />
            </Space>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={16} xl={15} xxl={24}>
                    <WeeklyRevenue pfrmDate={loadData.FrDate} ptoDate={loadData.ToDate} />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={16} xl={15} xxl={24}>
                <div className="options">
                        <div className="caption">Nhân viên kinh doanh</div>
                        <div className="option">
                            <SelectBox
                                dataSource={listSlp}
                                displayExpr="SlpName"
                                valueExpr="SlpCode"
                                searchEnabled={true}
                                value={loadDataSlp.Condition}
                                onValueChanged={SelectBoxChangeSlp}
                            />
                        </div>
                    </div>
                    <Chart
                        palette="Material"
                        dataSource={CompareCompanySalesSelectors.compareSlp}
                        stickyHovering={false}
                    >
                        <CommonSeriesSettings
                            argumentField="DocDate"
                            type="spline"
                            hoverMode="includePoints"
                        />
                        {
                            CompareCompanySalesSelectors.energySourcesTotal.map((item) => <Series
                                key={item.value}
                                valueField={item.value}
                                name={item.name} />)
                        }
                        <Margin bottom={20} />
                        <ArgumentAxis
                            valueMarginsEnabled={false}
                            discreteAxisDivisionMode="crossLabels"
                        >
                            <Grid visible={true} />
                        </ArgumentAxis>
                        <Legend
                            verticalAlignment="bottom"
                            horizontalAlignment="center"
                            itemTextPosition="bottom"
                        />
                        <Export enabled={false} />
                        <Title text="Sản lượng bán của nhân viên kinh doanh theo kỳ ">
                            <Subtitle text="ĐVT: Kg" />
                        </Title>
                        <Tooltip enabled={true} format="###,###,###" />
                    </Chart>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={16} xl={15} xxl={12}>
                    <div className="options">
                        <div className="caption">Loại giấy</div>
                        <div className="option">
                            <SelectBox
                                dataSource={listPro2}
                                displayExpr="Name"
                                valueExpr="Code"
                                searchEnabled={true}
                                value={loadDataPro2.Condition}
                                onValueChanged={SelectBoxChange}
                            />
                        </div>
                    </div>
                    <Chart
                        id="chart"
                        palette="Soft"
                        dataSource={CompareCompanySalesSelectors.comparePro2}
                    >
                        <CommonSeriesSettings
                            argumentField="DocDate"
                            type="bar"
                            barPadding={0.5}
                        />
                        {
                            CompareCompanySalesSelectors.energySourcesTotal.map((item) => <Series
                                key={item.value}
                                valueField={item.value}
                                name={item.name} />)
                        }
                        <Legend
                            verticalAlignment="bottom"
                            horizontalAlignment="center"
                        />
                        <Margin left={20} />
                        <Export enabled={true} />
                        <Title text="Sản lượng theo loại giấy" subtitle="(ĐVT: Kg)" />
                        <Tooltip enabled={true} format="###,###,###" />
                    </Chart>

                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={15} xxl={12}>
                    <div className="options">
                        <div className="caption">Nhãn hàng</div>
                        <div className="option">
                            <SelectBox
                                dataSource={listPro4}
                                displayExpr="Name"
                                valueExpr="Code"
                                searchEnabled={true}
                                value={loadDataPro4.Condition}
                                onValueChanged={SelectBoxChangePro4}
                            />
                        </div>
                    </div>
                    <Chart
                        id="chart"
                        palette="Soft"
                        dataSource={CompareCompanySalesSelectors.comparePro4}
                    >
                        <CommonSeriesSettings
                            argumentField="DocDate"
                            type="bar"
                            barPadding={0.5}
                        />
                        {
                            CompareCompanySalesSelectors.energySourcesTotal.map((item) => <Series
                                key={item.value}
                                valueField={item.value}
                                name={item.name} />)
                        }
                        <Legend
                            verticalAlignment="bottom"
                            horizontalAlignment="center"
                        />
                        <Margin left={20} />
                        <Export enabled={true} />
                        <Title text="Sản lượng theo nhãn hàng" subtitle="(ĐVT: Kg)" />
                        <Tooltip enabled={true} format="###,###,###" />
                    </Chart>
                </Col>
            </Row>
        </>
    );

}

export default CompareCompanySales;